import React, { useEffect, useMemo, useState } from 'react';
import styles from './Training.module.scss';
import { imageBasePath } from 'constants';
import { List, ListItem } from '@material-ui/core';
import { useLearningPathsStore } from './LearningPaths/LearningPaths.store';
import { buildStyles, CircularProgressbar } from 'react-circular-progressbar';
import { ProgressBar } from 'shared_ui_components';
import { getUserPreferencesApi } from '../apiServices';
import Organization from 'infrastructure/Organization';
import { useSalesRepView } from 'features/salesRepView/SalesRepView.hook';
import { useGetFF } from '@fstack-tech/ff_react_module';

const RepTrainingHeader = ({ readinessIndex, completed, total }) => {
  const {
    activeTabRep,
    setSelectedRepLearningPathID,
    setActiveTabRep,
    userPreferencesLP,
    setUserPreferencesLP,
    selectedRepLearningPathID,
  } = useLearningPathsStore();
  const { isEnabled: ff_learning_paths } = useGetFF({ flag_id: 'learning_paths' });
  const { isEnabled: ff_skill_paths_dashboards } = useGetFF({ flag_id: 'skill_paths_dashboards' });

  const [loading, setLoading] = useState(false);
  useEffect(() => {
    const getOnboardingInfo = async () => {
      try {
        setLoading(true);
        const response = await getUserPreferencesApi();
        if (response.statusCode === 200) {
          setUserPreferencesLP(response?.data);
        }
      } finally {
        setLoading(false);
      }
    };
    getOnboardingInfo();
  }, [setUserPreferencesLP]);
  useMemo(() => {
    if (ff_skill_paths_dashboards) setActiveTabRep('dashboard');
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [ff_learning_paths]);
  const handleSelectTab = (selected) =>
    setActiveTabRep(selected);

  const handleBack = () => {
    setSelectedRepLearningPathID('');
    handleSelectTab(activeTabRep);
  };

  const { isActive } = useSalesRepView();
  const showTab = useMemo(() => {
    if (Organization.isAdmin() && isActive) return true;
    if (Object.keys(userPreferencesLP?.onboarding || {}).length > 0)
      return userPreferencesLP?.onboarding?.completed || !userPreferencesLP?.onboarding?.required;
    return !loading;
  }, [userPreferencesLP, loading]);

  return (
    <div className={styles.newRepTrainingHeader}>
      <div className={styles.firstContainer}>
        {/* Text header */}
        {selectedRepLearningPathID && (
          <button className={styles.backButton} onClick={handleBack}>
            <img src={imageBasePath + 'back_arrow.svg'} alt="img" />
          </button>
        )}
        <div className={styles.titleWrapper}>
          <div className={styles.title}>
            <img src={imageBasePath + 'training_dashboard_icon.svg'} alt="" />
            <h1 className="heading3">{ff_learning_paths ? 'Upskilling' : 'Training'}</h1>
          </div>
          {!ff_learning_paths && (
            <p className="supportText">Complete all of the modules to boost your sales readiness</p>
          )}
        </div>
        {/* Tab buttons */}
        <div className={styles.tabs}>
          <List className="listInline tabList">
            {!ff_skill_paths_dashboards ? (
              <ListItem
                key={'training'}
                className={`listInlineItem heading6 ${activeTabRep === 'training' ? 'active' : ''}`}
                onClick={() => handleSelectTab('training')}
              >
                {!ff_learning_paths ? 'Training Modules' : 'Skill Sets'}
              </ListItem>
            ) : (
              <ListItem
                key={'dashboard'}
                className={`listInlineItem heading6 ${
                  activeTabRep === 'dashboard' ? 'active' : ''
                }`}
                onClick={() => handleSelectTab('dashboard')}
              >
                Skill Paths
              </ListItem>
            )}
            {showTab ? (
              <ListItem
                key={'learning'}
                className={`listInlineItem heading6 ${activeTabRep === 'learning' ? 'active' : ''}`}
                onClick={() => handleSelectTab('learning')}
              >
                {`${ff_learning_paths ? 'Skill Paths' : 'Learning Paths'}`}
              </ListItem>
            ) : null}
          </List>
        </div>
      </div>

      {/* Progress bars */}
      {activeTabRep === 'training' && (
        <ProgressBars readinessIndex={readinessIndex} completed={completed} total={total} />
      )}
    </div>
  );
};

const ProgressBars = ({ readinessIndex, completed, total }) => {
  const { isEnabled: ff_learning_paths } = useGetFF({ flag_id: 'learning_paths' });
  if (!readinessIndex) return null;

  return (
    <div className={styles.secondContainer}>
      <div className={styles.readinessInfoWrapper}>
        <div className="circularProgressbar">
          <CircularProgressbar
            strokeWidth={10}
            value={readinessIndex}
            styles={buildStyles({
              textColor: ' #778DA9',
              pathColor: '#00D2AD',
              trailColor: '#D8E1E9',
              textSize: '16px',
              strokeLinecap: 'butt',
              pathTransition: 'none',
            })}
          />
        </div>
        <div className="supportText">
          <p className={styles.value}>{readinessIndex}%</p>
          <p>Sales Readiness Index</p>
        </div>
      </div>

      <div className={styles.completedCountWrapper}>
        <p>
          <span className={`${styles.value} heading6`}>{`${completed || 0}/${total || 0} `}</span>
          <span className="supportText" style={{ marginTop: 2 }}>
            {!ff_learning_paths ? 'Modules Completed' : 'Skill Sets Completed'}
          </span>
        </p>
        <div className={styles.progressBlk}>
          <ProgressBar
            value={completed}
            max={total}
            className={styles.stepProgress + ' stepProgress'}
          />
        </div>
      </div>
    </div>
  );
};

export default RepTrainingHeader;
